import { createFileRoute } from '@tanstack/react-router';
import { DashboardPage } from '../../features/tenancy';

export const Route = createFileRoute('/portal/')({ component: DashboardPage });
